module.exports = __webpack_public_path__ + "static/img/cjfw-companyProducts4.c51c881c.png";